import { Route } from 'react-router-dom';

// Pages.
import ProjectPlanPage from 'pages/sun_capital/master-plane/Aurora/Townhouse/plan/ProjectPlanPage';
import ProjectGalleryPage from 'pages/sun_capital/master-plane/Aurora/Townhouse/gallery/ProjectGalleryPage';
import PaymentPage from 'pages/sun_capital/master-plane/Aurora/Townhouse/payment/PaymentPage';
const Index = () => {
  return (
    <>
      <Route exact path="/sun_capital/master-plan/aurora/townhouse/plan">
        <ProjectPlanPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/aurora/townhouse/gallery`}>
        <ProjectGalleryPage />
      </Route>
      <Route exact path={`/sun_capital/master-plan/aurora/townhouse/payment`}>
        <PaymentPage />
      </Route>
    </>
  );
};

export default Index;
